goog.provide("shadow.js.shim.module$$tanstack$react_query_devtools");
goog.provide("module$shadow_js_shim_module$$tanstack$react_query_devtools");
shadow.js.shim.module$$tanstack$react_query_devtools = shadow.js.nativeProvides["@tanstack/react-query-devtools"] = shadow$bridge("@tanstack/react-query-devtools");
module$shadow_js_shim_module$$tanstack$react_query_devtools.default = shadow.js.shim.module$$tanstack$react_query_devtools;
